// extracted by mini-css-extract-plugin
export default {"card":"y1-z"};